import React, { Component } from "react";
import userProfile from "../img/user-profile.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import "../css/header.css";

class Header extends Component {
  constructor(props) {
    super(props);
    this.cerrarSession = props.cerrarSession;
    this.state = {
      dropdownOpen: false, // Estado para manejar la apertura/cierre del menú de usuario
      theme: props.theme || "light", // Estado local para el tema actual
    };
  }

  // Método para alternar el menú de usuario
  toggleDropdown = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  // Método para cerrar el menú de usuario
  closeDropdown = () => {
    this.setState({ dropdownOpen: false });
  };

  // Método para alternar la visibilidad del sidebar
  toggleSidebar = () => {
    const sidebar = document.getElementById("sidebar");
    if (sidebar) {
      sidebar.classList.toggle("collapsed");
    }
  };

  // Método para alternar el tema
  toggleTheme = () => {
	const newTheme = this.state.theme === "light" ? "dark" : "light";
	this.setState({ theme: newTheme }, () => {
	  document.body.setAttribute("data-bs-theme", newTheme);
	  if (this.props.toggleTheme) {
		this.props.toggleTheme(newTheme); // Propagar al componente padre
	  }
	});
  };
  

  render() {
    const { dropdownOpen, theme } = this.state;
    const { user } = this.props;

    return (
      <nav className="navbar navbar-expand navbar-light navbar-bg py-2">
        {/* Sidebar Toggle */}
        <a
          className="sidebar-toggle"
          onClick={this.toggleSidebar}
          title="Toggle Sidebar"
        >
          <i className="hamburger align-self-center"></i>
        </a>

        <div className="navbar-collapse collapse">
          <ul className="navbar-nav ms-auto align-items-center">
            {/* Botón de cambio de tema */}
            <li className="nav-item me-2">
              <button
                className="btn btn-light btn-sm rounded-circle"
                onClick={this.toggleTheme}
                title={theme === "light" ? "Modo oscuro" : "Modo claro"}
              >
                <FontAwesomeIcon icon={theme === "light" ? faMoon : faSun} />
              </button>
            </li>

            {/* Menú de usuario */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle d-flex align-items-center"
                href="#"
                role="button"
                onClick={this.toggleDropdown}
              >
                <img
                  src={user.urlImage || userProfile}
                  alt="User Profile"
                  className="img-fluid rounded-circle me-2"
                  style={{ width: 32, height: 32, objectFit: "cover" }}
                />
                <span className="text">{user.userName || "Usuario"}</span>
              </a>
              {dropdownOpen && (
                <div
                  className="dropdown-menu dropdown-menu-end show"
                  onMouseLeave={this.closeDropdown}
                >
                  <Link to="/UserProfile" className="dropdown-item">
                    <FontAwesomeIcon icon={faUserCircle} className="me-2" />
                    Perfil
                  </Link>
                  <Link to="/settings" className="dropdown-item">
                    Configuración
                  </Link>
                  <div className="dropdown-divider"></div>
                  <a
                    href="#"
                    className="dropdown-item"
                    onClick={() => {
                      this.closeDropdown();
                      this.cerrarSession();
                    }}
                  >
                    <FontAwesomeIcon icon="sign-out-alt" className="me-2" />
                    Cerrar sesión
                  </a>
                </div>
              )}
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default Header;
